import { Component, OnInit, OnChanges, OnDestroy, Input, HostListener, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { TicketsService } from 'src/app/services/tickets-service/tickets.service';

@Component({
  selector: 'app-tickets-ticket-info-card',
  templateUrl: './tickets-ticket-info-card.component.html',
  styleUrls: ['./tickets-ticket-info-card.component.scss']
})
export class TicketsTicketInfoCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() ticket;
  centerList;
  editingLocked: boolean;
  updateTicketSubscription: Subscription;
  basicDataForm = new FormGroup({
    active: new FormControl({ value: true, disabled: true }),
    ticketName: new FormControl({ value: null, disabled: true }, Validators.required)
  });

  constructor(private eRef: ElementRef,
    private snackbarService: SnackBarService,
    private ticketsService: TicketsService) {
    this.editingLocked = true;
  }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.ticket) {
      this.resetForm();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
    } else {
      if (event.path[0].className !== 'mat-option-text') {
        if (this.ticket && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
        }
      }
    }
  }

  public submitForm() {
    this.updateTicketSubscription = this.ticketsService.updateTicketInfo(this.ticket.InternalId, this.basicDataForm.get('active').value, this.basicDataForm.get('ticketName').value).subscribe(
      (res) => {
        this.snackbarService.open('tickets-page.snackbar messages.update ticket success', 'success');
        this.lockEdition();
        this.ticketsService.refreshTicket();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
      } else {
        this.snackbarService.open(validation, 'error');
      }
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('ticketName').valid) {
      return 'tickets-page.snackbar messages.name ticket error';
    } else {
      return true;
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      active: this.ticket.Active,
      ticketName: this.ticket.TicketName
    });
  }

  public unlockEdition() {
    this.basicDataForm.get('active').enable();
    this.basicDataForm.get('ticketName').enable();
    this.editingLocked = false;
  }

  public lockEdition() {
    this.basicDataForm.get('active').disable();
    this.basicDataForm.get('ticketName').disable();
    this.editingLocked = true;
  }

  ngOnDestroy() {
    if (this.updateTicketSubscription) { this.updateTicketSubscription.unsubscribe(); }
  }

}
